// PURPOSE: A row of counts that each pick a list, shared by Home and the list pages (Tickets, Clients, Builds).
// CONTRACT: Phin's UI taste 2026-10-18: counts at a glance, zeros greyed, red only for broken or late, one picked at a time.
// DEPENDS: home.css .home-tiles / .home-tile styles.
// CEILING: Presentation only; the page decides what each count means and what picking it shows.
import type { CSSProperties } from 'react';

export type NumberTile = { key: string; label: string; count: number; alert?: boolean };

export function NumbersBar({ tiles, picked, onPick, label }: { tiles: NumberTile[]; picked?: string; onPick(key: string): void; label: string }) {
 if (tiles.length < 2) return null;
 return <div className="home-tiles" role="group" aria-label={label} style={{ '--tiles': tiles.length } as CSSProperties}>{tiles.map(tile =>
  <button key={tile.key} type="button" className={`home-tile${tile.alert ? ' is-alert' : ''}${tile.count ? '' : ' is-zero'}`} aria-pressed={tile.key === picked} onClick={() => onPick(tile.key)}>
   <strong>{tile.count}</strong><span>{tile.label}</span>
  </button>)}</div>;
}
